import API, { defaultHeaders, IRI } from '@/api';

const fetchDetail = id => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}${IRI.invitation}${id}`, { headers });
};

export default fetchDetail;
